import React from "react";
import { Chip } from "@mui/material";
import {
  HourglassEmpty,
  AccessTime,
  CheckCircle,
  Cancel,
} from "@mui/icons-material";

const getStatusDetails = (status) => {
  switch (status) {
    case 1:
      return {
        label: "Pending",
        color: "#FFF3CD", // Light Yellow
        icon: <AccessTime />,
      };
    case 2:
      return {
        label: "Approved",
        color: "#D4EDDA", // Light Green
        icon: <CheckCircle />,
      };
    case 3:
      return {
        label: "Rejected",
        color: "#F8D7DA", // Light Red
        icon: <Cancel />,
      };
    default:
      return {
        label: "Unknown",
        color: "#E9ECEF", // Light Gray
        icon: <HourglassEmpty />,
      };
  }
};

const StatusChip = ({ status }) => {
  const { label, color, icon } = getStatusDetails(status);

  return (
    <Chip
      label={label}
      icon={icon}
      sx={{
        backgroundColor: color,
        color: "#333", // Text color dark for readability
        fontWeight: 600,
        borderRadius: "8px",
        "& .MuiChip-icon": {
          color: "#333",
        },
      }}
    />
  );
};

export default StatusChip;
